import React, { Component } from 'react';
import {toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {API_URL} from '../../../constants';
import {updateValueInJson, validateAccesoGeneral, getRoles} from '../../../functions';
import axios from 'axios';
import $ from 'jquery';

export default class AgregarCategoriaHerramientaAnalisis extends Component {

    constructor(props) {
        super(props); 

        this.state = { 
            categoriaLongitud:0,
            resource: {
                chan_Nombre:"",
                chan_Orden: this.props.location.state !== undefined ? this.props.location.state.totalRegistros + 1 : "",
                chan_Activo: true
            },
            Validacion: {
                chan_Nombre: {
                    Error: false,                    
                },
                chan_Orden: {
                    Error: false,                    
                }
            },
            hasError:false,    
            hasErrorProceso:false,        
            added: false,
            security: cookie.load('user'),
            roles: [],
            agrupador:"",
            menuGeneral:[]
          }
        this.handleInputChange = this.handleInputChange.bind(this);

      }

      componentDidMount()
      {
          if($('#containerPanel').is("*")){
              $('#containerPanel').hide();
          }

            let locationState = this.props.location.state;
            let pathNameList = "/categorias-herramienta-analisis";

            var roles = getRoles(this.state.security);
            var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

            validateAccesoGeneral(locationState, pathNameList, rol); 
      }
    
    handleClickCancel(e) {

        if(e != undefined){
            e.preventDefault();
        }
        
        const {history: {push}} = this.props;    
        push('/categorias-herramienta-analisis');
     }

     callFunctionButton = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.chan_Nombre == '') {  
            
            newState.Validacion.chan_Nombre = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.chan_Orden == '') {  
            newState.Validacion.chan_Orden = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}CategoriaHerramientaAnalisisUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'chan_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                
                let stateResponse = this.state;

                stateResponse.added = true;
                stateResponse.resource.chan_Nombre = '';
                stateResponse.resource.chan_Orden += 1 ;

                this.setState(stateResponse);

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        toast.error('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let longitudCategoria = this.state.categoriaLongitud;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'chan_Nombre'){
            longitudCategoria = value.length;
        }
        this.setState({
            resource: copyResource,
            categoriaLongitud: longitudCategoria,
            Validacion: validaciones
        });     
    }

    render() {
        return (
            <div className="">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de Configuración General
                        </a >
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Agregar Categoría Herramienta Análisis</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Agregar Categoría Herramienta Análisis
                </div>

                {
                    this.state.hasErrorProceso ? 
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar el registro.</div>
                        </div>
                    </div> : null
                }   

                {
                    this.state.added ? 
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se realizó el registro correctamente.</div>
                        </div>
                    </div>: null
                }             
                
                <div className="div_Modulos_Noticias">
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Categoría" name='chan_Nombre' value={this.state.resource.chan_Nombre} maxLength={25} className={this.state.Validacion.chan_Nombre.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                        <span data-length={25}>{this.state.categoriaLongitud}/25</span>
                    </div>
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Orden" name='chan_Orden' value={this.state.resource.chan_Orden} maxLength={2} className={this.state.Validacion.chan_Orden.Error ? "error" : ""} onChange={this.handleInputChange} onChange={this.handleInputChange}/>
                    </div>
                    <div className="divContenedorBtn_Noticias">
                        <a href="#"  className="btnActivo"  onClick={(e) => this.callFunctionButton(e)}>GUARDAR </a>
                        <a href="#"  onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />

            </div>
        )
    }
}
